import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
// import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { App, NavController } from 'ionic-angular';

import { Camera, CameraOptions } from '@ionic-native/camera';
import { MediaCapture, MediaFile, CaptureError, CaptureVideoOptions } from '@ionic-native/media-capture';
import { VideoEditor } from '@ionic-native/video-editor';
import { WebCamComponent } from 'ack-angular-webcam';
import { File } from '@ionic-native/file';
import { Platform } from 'ionic-angular';
import { Storage } from '@ionic/storage';

import { ProofProvider } from '../proof/proof';
import { DateTimeProvider } from '../../providers/datetime/datetime';
import { FileProvider } from '../../providers/file/file';
import { AlertProvider } from '../../providers/alert/alert';

import { MediaItem } from '../../models/mediaitem';
import { Geolocation } from "@ionic-native/geolocation";
import { NativeGeocoder, NativeGeocoderOptions, NativeGeocoderReverseResult } from "@ionic-native/native-geocoder";
import { HttpClient } from "@angular/common/http";

import * as Config from "../../app/app.config";
import { Response } from "@angular/http";
import { Media, MediaObject } from '@ionic-native/media';


/*
  Generated class for the MediaProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class MediaProvider {

  userLocation: any;
  userIp: any;


  recording: boolean = false;
  filePath: string;
  fileName: string;
  audio: MediaObject;
  audioList: any[] = [];

  constructor(
    private camera: Camera,
    private mediaCapture: MediaCapture,
    private videoEditor: VideoEditor,
    private file: File,
    private platform: Platform,
    private storage: Storage,
    private proof: ProofProvider,
    private dateTimeProvider: DateTimeProvider,
    private fileProvider: FileProvider,
    protected app: App,
    private alertProvider: AlertProvider,
    private geolocation: Geolocation,
    private nativeGeocoder: NativeGeocoder,
    private http: HttpClient,
    private media: Media,
  ) {
    console.log('Hello MediaProvider Provider');
    this.getIp();
    this.getPosition();
  }

  get navCtrl(): NavController {
    return this.app.getRootNav();
  }
async takeSelfie(returnData: boolean = false): Promise<any> {
    let that = this;
    const options: CameraOptions = {
      quality: 60,
      targetWidth: 800,
      targetHeight: 1200,
      correctOrientation: true,
      saveToPhotoAlbum: false,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.CAMERA,
      cameraDirection: this.camera.Direction.FRONT
    };

    return this.camera.getPicture(options).then((dataUrl) => {
      return new Promise((resolve, reject) => {
        if (!returnData) {
          if (dataUrl) {
            that.addMediaAsBase64AndKind(dataUrl, 'PS', that.userIp, that.userLocation.administrativeArea);
            resolve(true);
          } else {
            reject(false);
          }
        } else {
          if (dataUrl) {
            resolve(dataUrl);
          } else {
            reject(null);
          }
        }
      });
    }, (error) => {
      // Handle error
      console.log(error);
      console.log('Without selfie');

      return new Promise((resolve, reject) => {
        if (!returnData) {
          reject(false);
        } else {
          reject(null);
        }
      });
    });
  }

  async takeFrontIdentification(): Promise<any> {
    let that = this;
    const options: CameraOptions = {
      quality: 70,
      targetWidth: 800,
      targetHeight: 1200,
      correctOrientation: true,
      saveToPhotoAlbum: false,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.CAMERA,
      cameraDirection: this.camera.Direction.BACK
    };

    return this.camera.getPicture(options).then((dataUrl) => {
      return new Promise((resolve, reject) => {
        if (dataUrl) {
          // that.addMediaAsFilePathAndKind(fileUri, 'PF');
          that.addMediaAsBase64AndKind(dataUrl, 'PF', that.userIp, that.userLocation.administrativeArea);
          resolve(true);
        } else {
          reject(false);
        }
      });
    }, (err) => {
      // Handle error
      console.log(err);
      console.log('Without picture of document front');

      return new Promise((resolve, reject) => {
        reject(false);
      });
    });
  }

  async takeBackIdentification(): Promise<any> {
    let that = this;
    const options: CameraOptions = {
      quality: 70,
      targetWidth: 800,
      targetHeight: 1200,
      correctOrientation: true,
      saveToPhotoAlbum: false,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.CAMERA,
      cameraDirection: this.camera.Direction.BACK
    };

    return this.camera.getPicture(options).then((dataUrl) => {
      return new Promise((resolve, reject) => {
        if (dataUrl) {
          //that.addMediaAsFilePathAndKind(fileUri, 'PB');
          that.addMediaAsBase64AndKind(dataUrl, 'PB', that.userIp, that.userLocation.administrativeArea);
          resolve(true);
        } else {
          reject(false);
        }
      });
    }, (err) => {
      // Handle error
      console.log(err);
      console.log('Without picture of document back');

      return new Promise((resolve, reject) => {
        reject(false);
      });
    });
  }

  takeAudio(questionId, seconds, secondsRemaining){
  let that = this;
/**
 * @name Media
 * @description
 * This plugin provides the ability to record and play back audio files on a device.
 *
 * @usage
 * ```typescript
 * import { Media, MediaObject } from '@ionic-native/media';
 *
 *
 * constructor(private media: Media) { }
 *
 *
 * ...
 *
 *
 * // Create a Media instance.  Expects path to file or url as argument
 * // We can optionally pass a second argument to track the status of the media
 *
 * const file: MediaObject = this.media.create('file.mp3');
 *
 * // to listen to plugin events:
 *
 * file.onStatusUpdate.subscribe(status => console.log(status)); // fires when file status changes
 *
 * file.onSuccess.subscribe(() => console.log('Action is successful'));
 *
 * file.onError.subscribe(error => console.log('Error!', error));
 *
 * // play the file
 * file.play();
 *
 * // pause the file
 * file.pause();
 *
 * // get current playback position
 * file.getCurrentPosition().then((position) => {
 *   console.log(position);
 * });
 *
 * // get file duration
 * let duration = file.getDuration();
 * console.log(duration);
 *
 * // skip to 10 seconds (expects int value in ms)
 * file.seekTo(10000);
 *
 * // stop playing the file
 * file.stop();
 *
 * // release the native audio resource
 * // Platform Quirks:
 * // iOS simply create a new instance and the old one will be overwritten
 * // Android you must call release() to destroy instances of media when you are done
 * file.release();
 *
 *
 *
 * // Recording to a file
 * const file: MediaObject = this.media.create('path/to/file.mp3');
 *
 * file.startRecord();
 *
 * file.stopRecord();
 *
 *
 * ```
 *
 * Some hints if you are using iOS and recording doesn't work:
 * 1.) Try to use a absolute file path but remove beginning "file://".
 * Then it looks like: `/var/mobile/Containers/Data/Application/AF438B8B-7724-4FBB-8E69-083463224FC4/tmp/my_file.m4a`
 * Example: `this.media.create(this.file.tempDirectory.replace(/^file:\/\//, '') + 'my_file.m4a')`
 * 2.) If that's not working, too, create the file before using.
 * Example:
 * ```typescript
 * import { Media, MediaObject } from '@ionic-native/media';
 * import { File } from '@ionic-native/file';
 *
 * ...
 *
 * constructor(private media: Media, private file: File) { }
 *
 * ...
 *
 * this.file.createFile(this.file.tempDirectory, 'my_file.m4a', true).then(() => {
 *   let file = this.media.create(this.file.tempDirectory.replace(/^file:\/\//, '') + 'my_file.m4a');
 *   file.startRecord();
 *   window.setTimeout(() => file.stopRecord(), 10000);
 * });
 * ```
 *
 * You can find the reasons here: https://github.com/ionic-team/ionic-native/issues/1452#issuecomment-299605906
 * @classes
 * MediaObject
 * @interfaces
 * MediaError
 */

  if(this.platform.is('ios')){

    this.fileName = this.fileProvider.generateName() + '.m4a';
    this.filePath = this.file.tempDirectory.replace(/^file:\/\//, '') + this.fileName;
    this.audio = this.media.create(this.filePath);

  }else if (this.platform.is('android')){
    this.fileName = this.fileProvider.generateName() + '.3gp';
    this.filePath = this.file.externalDataDirectory.replace(/file:\/\//g, '') + this.fileName;
    this.audio = this.media.create(this.filePath);
  }


    this.audio.startRecord();
    console.log('start audio record');

    let kind = null;
    if(questionId != null){
      kind = "QA";
    }else{
      kind = "PA";
    }
      setTimeout(() => {
        //this.stopRecord();
        this.audio.stopRecord();
        console.log("parei a gravação" + new Date());
        let audioOriginal =  this.filePath;
        console.log(audioOriginal);
        return new Promise((resolve, reject) => {
          if (audioOriginal) {
            that.addMediaAsFilePathAndAudio(questionId,'file://' + audioOriginal, kind, seconds, secondsRemaining, that.userIp, that.userLocation.administrativeArea);
            resolve(true);
          } else {
            reject(false);
          }
        });

      }, 15000);

  }

  async takeMovie(): Promise<any> {
    let that = this;
    let options: CaptureVideoOptions = {
      limit: 1,
      duration: 30,
      quality: 0
    };

    return this.mediaCapture.captureVideo(options).then((data: MediaFile[]) => {
      if (data.length > 0) {
        let movieOriginal = data[0].fullPath;
        console.log(movieOriginal);
        try {
          let extension = /.+\.(.+)$/.exec(movieOriginal)[1];
          console.log('Extension: ' + extension);

          if (extension !== '3gp') {
            //that.spinnerDialog.show('Aguarde', 'Otimizando o vídeo...', true);
            that.alertProvider.doWaiting('Otimizando o vídeo...');

            let fileName = this.fileProvider.generateName();
            console.log('Output name: ' + fileName);

            that.videoEditor.transcodeVideo({
              fileUri: movieOriginal, // the path to the video on the device
              outputFileName: fileName, // the file name for the transcoded video
              outputFileType: that.videoEditor.OutputFileType.MPEG4, // android is always mp4
              optimizeForNetworkUse: that.videoEditor.OptimizeForNetworkUse.YES, // ios only
              saveToLibrary: false, // optional, defaults to true
              deleteInputFile: false, // optional (android only), defaults to false
              maintainAspectRatio: true, // optional (ios only), defaults to true
              // width: 640, // optional, see note below on width and height
              // height: 640, // optional, see notes below on width and height
              width: 800, // optional, see note below on width and height
              // height: 1200, // optional, see notes below on width and height
              videoBitrate: 1000000, // optional, bitrate in bits, defaults to 1 megabit (1000000)
              fps: 24, // optional (android only), defaults to 24
              audioChannels: 2, // optional (ios only), number of audio channels, defaults to 2
              audioSampleRate: 44100, // optional (ios only), sample rate for the audio, defaults to 44100
              audioBitrate: 128000, // optional (ios only), audio bitrate for the video in bits, defaults to 128 kilobits (128000)
              progress: function (info) {
                console.log('TranscodeVideo progress callback, info: ' + info);
              } // info will be a number from 0 to 100
            }).then((fileUri: string) => {
              console.log('Video transcode success', fileUri);

              // Try to remove old and big file
              that.file.resolveLocalFilesystemUrl(movieOriginal).then(entry => {
                console.log('Captured video file ' + entry.name);
                entry.remove(() => {
                  console.log('Deleted');
                }, e => console.log(e));
              }).catch(e => console.log(e));

              that.alertProvider.doWaitingHide();

              return new Promise((resolve, reject) => {
                if (fileUri) {
                  that.addMediaAsFilePathAndKind('file://' + fileUri, 'MV', null, null);
                  resolve(true);
                } else {
                  reject(false);
                }
              });
            }).catch((error: any) => {
              console.log('Video transcode error', error);

              that.alertProvider.doWaitingHide();

              return new Promise((resolve, reject) => {
                if (movieOriginal) {
                  that.addMediaAsFilePathAndKind(movieOriginal, 'MV', null, null);
                  resolve(true);
                } else {
                  reject(false);
                }
              });
            });
          } else {
            console.log('Bypassed the compression');

            return new Promise((resolve, reject) => {
              if (movieOriginal) {
                that.addMediaAsFilePathAndKind(movieOriginal, 'MV', null, null);
                resolve(true);
              } else {
                reject(false);
              }
            });
          }
        } catch (e) {
          console.log('Problems on fetch the extension');

          return new Promise((resolve, reject) => {
            if (movieOriginal) {
              that.addMediaAsFilePathAndKind(movieOriginal, 'MV', null, null);
              resolve(true);
            } else {
              reject(false);
            }
          });
        }
      } else {
        console.log('Without video');

        return new Promise((resolve, reject) => {
          reject(false);
        });
      }
    }, (err: CaptureError) => {
      // Handle error
      console.log(err);

      return new Promise((resolve, reject) => {
        reject(false);
      });
    });
  }

  takeWebcamPicture(webcam: WebCamComponent, onSuccess: any) {


    if ((this.proof.hasProof()) && (webcam)) {
      webcam.getBase64().then(data => {
        if (data) {
          var image = new Image();
          image.onload = (imageEvent) => {
            // Resize the image using canvas
            let canvas = document.createElement('canvas');
            let max_size = 800; // TODO : max size for a pic
            let width = image.width;
            let height = image.height;

            if (width > height) {
              if (width > max_size) {
                height *= max_size / width;
                width = max_size;
              }
            } else if (height > max_size) {
              width *= max_size / height;
              height = max_size;
            }
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);

            if (onSuccess) {
              // Getting base64 string
              onSuccess(canvas.toDataURL('image/jpeg', 0.75));
            }
          };
          image.src = data;
        }
      }).catch((error: any) => {
        console.error(error);
      });
    }
  }

  addBase64PhotoAsKind(content: string, kind: string) {
    let that = this;
    let fileName = this.fileProvider.generateName() + '.jpg';

    this.fileProvider.saveBase64AsFile(this.file.dataDirectory, fileName, content, 'image/jpeg').then(filePath => {
      that.addMediaAsFilePathAndKind(filePath, kind, that.userIp, that.userLocation.administrativeArea);
    }).catch(error => {
      console.log(error);
    });
  }

  addBase64PhotoFromQuestion(questionId: number, seconds: number, secondsRemaining: number,
    content: string, callback: any = null) {
    let that = this;
    let item = new MediaItem();
    item.kind = 'QT';
    item.questionId = questionId;
    item.base64 = true;
    item.contentOrPath = content;
    item.captured = this.dateTimeProvider.getISOString();
    // Relative to photo on question
    item.seconds = seconds;
    item.secondsRemaining = secondsRemaining;
    item.note = that.userIp;
    item.extra = that.userLocation.administrativeArea;
    console.log(item);

    this.addMedia(item, callback);
  }

  private addMediaAsBase64AndKind(content: string, kind: string, note: string, extra: string) {
    console.log('media.addMediaAsBase64AndKind');
    // console.log('Directory: '+ path);
    // console.log('Content: '+ content);

    // Create media
    let item = new MediaItem();
    item.kind = kind;
    item.base64 = true;
    item.note = note;
    item.contentOrPath = content;
    item.captured = this.dateTimeProvider.getISOString();
    item.extra = extra;
    console.log(item);

    this.addMedia(item);
  }

  private addMediaAsFilePathAndKind(filePath: string, kind: string, note: string, extra: string) {
    console.log('media.addMediaAsFilePathAndKind');
    // console.log('Directory: '+ path);
    console.log('Filename: ' + filePath);

    // Create media
    let item = new MediaItem();
    item.kind = kind;
    item.contentOrPath = filePath;
    item.captured = this.dateTimeProvider.getISOString();
    item.note = note;
    item.extra = extra;
    console.log(item);

    this.addMedia(item);
  }

  private addMediaAsFilePathAndAudio(questionId: number, filePath: string, kind: string, seconds: number, secondsRemaining: number, note: string, extra: string) {
    console.log('media.addMediaAsFilePathAndAudio');
    // console.log('Directory: '+ path);
    console.log('Filename: ' + filePath);

    // Create media
    let item = new MediaItem();
    item.kind = kind;
    item.questionId = questionId;
    item.contentOrPath = filePath;
    item.captured = this.dateTimeProvider.getISOString();
    // Relative to audio on question
    item.seconds = seconds;
    item.secondsRemaining = secondsRemaining;
    item.note = note;
    item.extra = extra;
    console.log(item);

    this.addMedia(item);
  }

  addMedia(item: MediaItem, callback: any = null) {
    if (this.proof.hasProof()) {
      item.id = this.dateTimeProvider.getString();
      this.storage.set('userproof_' + this.proof.getId() + '_file_' + item.id, JSON.stringify(item));
    }

    if (callback) {
      callback(item);
    }
  }

  getMedias(): Observable<Promise<any>[]> {
    let that = this;

    return Observable.create(observer => {
      that.storage.keys().then((keys: string[]) => {
        const promises = [];

        keys.forEach((key: string) => {
          if (key.includes('userproof_' + this.proof.getId() + '_file')) {
            promises.push(that.storage.get(key));
          }
        });

        observer.next(promises);
        observer.complete();
      }).catch((error: any) => {
        observer.error(new Error(error));
      });
    });
  }

    getIp() {
      let that = this;

      that.http.get(Config.urlIp).subscribe((response: Response) => {
        that.userIp = response['origin'];
        return that.userIp;
      });
    }

    getPosition() {
      let that = this;

      that.geolocation.getCurrentPosition().then((resp) => {
        let options: NativeGeocoderOptions = {
          useLocale: true,
          maxResults: 1
        };

        that.nativeGeocoder.reverseGeocode(resp.coords.latitude, resp.coords.longitude, options)
            .then((result: NativeGeocoderReverseResult[]) => {
              that.userLocation = result[0];
            })
            .catch((error: any) => {
              that.userLocation = null;
              console.log(error)
            });


      }).catch((error) => {
        that.userLocation = null;
        console.log('Error getting location', error);
      });
    }

  public detectWebcam(callback: any) {
    let md = navigator.mediaDevices;

    if ((!md) || (!md.enumerateDevices)) {
      return callback(false);
    }

    md.enumerateDevices().then((devices: any) => {
      callback(devices.some((device: any) => ('videoinput' === device.kind)));
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/media/media.ts